import { call, put, takeLatest, delay } from 'redux-saga/effects';

import api from '~/services/api';
import {
	createConsent,
	createConsentSuccess,
	createConsentFailure,
	updateConsent,
	updateConsentSuccess,
	updateConsentFailure,
	getConsent,
	getConsentSuccess,
	getConsentFailure,
} from '.';

export default function* rootSaga() {
	yield takeLatest(createConsent, createConsentSaga);
	yield takeLatest(updateConsent, updateConsentSaga);
	yield takeLatest(getConsent, getConsentSaga);
}

function* createConsentSaga({ payload }) {
	try {
		yield delay(500);
		const { data } = yield call(api.post, `/consents`, payload);
		yield put(createConsentSuccess(data.data));
	} catch (error) {
		yield put(createConsentFailure(error.response.data.error));
	}
}

function* updateConsentSaga({ payload }) {
	try {
		yield delay(500);
		const { id, ...body } = payload;
		const { data } = yield call(api.patch, `/consents/${id}`, body);
		yield put(updateConsentSuccess(data.data));
	} catch (error) {
		yield put(updateConsentFailure(error.response.data.error));
	}
}

function* getConsentSaga({ payload }) {
	try {
		yield delay(500);
		const { consentId, companyId } = payload;
		const { data } = yield call(api.get, `/consents/${companyId}/${consentId}`);
		yield put(getConsentSuccess(data.data));
	} catch (error) {
		yield put(getConsentFailure(error.response.data.error));
	}
}
